'use strict';

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

module.exports = common$1;
